import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../common/modal';
import EquipmentForm from './EquipmentForm';

/**
 * Modal wrapper para o formulário de cadastro rápido de equipamentos.
 * Controla visibilidade e propaga callbacks.
 */
const EquipmentModalForm = ({ open, onClose, onSuccess, clienteId, currentLanguage }) => {

    const handleSuccess = (savedEquipment) => {
        if (onSuccess) {
            onSuccess(savedEquipment);
        }
        onClose();
    };

    return (
        <Modal
            open={open}
            onClose={onClose}
            title={currentLanguage.bepiService.shared.shared_equip_modal_title}
        >
            <EquipmentForm
                onSuccess={handleSuccess}
                onCancel={onClose}
                clienteId={clienteId}
                currentLanguage={currentLanguage}
            />
        </Modal>
    );
};

EquipmentModalForm.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onSuccess: PropTypes.func,
    clienteId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

EquipmentModalForm.defaultProps = {
    onSuccess: null,
    clienteId: null,
};

export default EquipmentModalForm;
